import { TimelineView } from '@/components/shared/timeline'
import { useTimelineQuery } from '@/services/timeline'
import { Alert, Box, CircularProgress } from '@mui/material'

interface InvestigationTimelineProps {
  investigationHash: string
  investigationName: string
}

export default function InvestigationTimeline({ investigationHash, investigationName }: InvestigationTimelineProps) {
  const { data: events = [], isLoading, isError } = useTimelineQuery(investigationHash, 'investigation')

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError) {
    return (
      <Alert severity='error' sx={{ mx: 2 }}>
        Failed to load timeline. Please try again later.
      </Alert>
    )
  }

  return (
    <TimelineView
      entityName={investigationName}
      events={events}
      totalItems={events.length}
      itemsPerPage={12}
      excludedFilters={['Patient', 'Order', 'Medication Requests', 'Tasks']}
    />
  )
}
